import { Component, OnInit } from '@angular/core';
import { DataManagerService } from '../../data/services/DataManager/data-manager.service';
import { ApiResponseModel } from '../../data/model/ApiResponseModel/api-response.model';
import { EventModel } from '../../data/model/EventModel/Event.model';
import { AppConstants } from '../../shared/constants/app-constants';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ErrorConstants } from "../../shared/constants/error-constants";
import { GetEventListingAction } from '../event-listing/get-event-listing.action';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ExportConstants } from '../../shared/constants/export-constants';
import { ExportModel } from '../../data/model/ExportModel/export-model';
import { debounceTime } from 'rxjs/operators';
import { ariaSort, SortDirection } from '../../ui/table/payarc-sort-icon.component';
import { PagerPage } from '../../ui/pager/payarc-pager.component';

@Component({
    selector: 'app-event-listing',
    templateUrl: './event-listing.component.html',
    styleUrls: ['./event-listing.component.css'],
    standalone: false
})
export class EventListingComponent extends GetEventListingAction implements OnInit {
  exportExcel : ExportModel[] = ExportConstants.eventsListExport;
  showExport = false;
  exportData = {exportServiceName: AppConstants.SERVICE_NAME_EXPORT_DASHBOARD + '/event', redirectUrl : '/events-and-logs', fileName: 'Payarc_Events_Report', heading : 'Event & logs '};
  dataManager: DataManagerService;
  eventList: ApiResponseModel<EventModel>;
  perPage = 20;
  route: ActivatedRoute;
  excel = 1;
  blob: any;
  // BaseListComponent.emptyListMsg defaults to the payee empty-state copy; override so an empty
  // (or errored, see getListErr) result set shows an events-specific message instead.
  protected emptyListMsg: string = ErrorConstants.eventDetailErrorMsg[0];

  constructor(dataManager: DataManagerService, router: Router, route: ActivatedRoute,snackBar: MatSnackBar) {
    super();
    this.snackBar = snackBar;
    this.loadFlag = true;
    this.router = router;
    this.errorMsg = null;
    this.route = route;
    this.redirect_link = '/event-details';
    this.searchHits = new Subject<void>();

    if (this.fetchIdAndKeyFromRouteQueryParams()) {
      this.getListUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_EVENT;
      this.includes = '?' + this.key + '=' + this.id;
    } else {
      this.getListUrl = AppConstants.BASE_URL + AppConstants.SERVICE_NAME_EVENT;
    }
    this.dataManager = dataManager;
    this.eventList = new ApiResponseModel();
    this.setUrl();
  }

  ngOnInit() {
    this.searchHits.pipe(debounceTime(600),).subscribe((res) => {
      if (!this.isNullOrUndefined(this.searchText)) {
        this.setUrl();
      }
    });
  }
  protected getListRes(eventResponse: ApiResponseModel<EventModel>) {
    this.loadFlag = false;
    this.eventList = eventResponse;
    this.metadata = eventResponse.meta.pagination;
    if (eventResponse.data.length === 0) {
      this.errorMsg = ErrorConstants.eventDetailErrorMsg[0];
    } else {
      this.errorMsg = null;
    }
  }

  protected getListErr(error: any) {
    // networkErrorHandler looks up the response BODY's own `status_code` field, which this
    // endpoint's error payloads (e.g. { message: 'server error' } on a search 500) don't carry —
    // it silently returns undefined, leaving errorMsg falsy and the stale pre-search eventList.data
    // on screen as if it were a valid (if mismatched) result set. Fall back to the real HTTP
    // status from the HttpErrorResponse so a failed search always surfaces an error state.
    this.errorMsg = this.networkErrorHandler(error.error, ErrorConstants.eventDetailErrorMsg)
      || ErrorConstants.eventDetailErrorMsg[error.status]
      || ErrorConstants.eventDetailErrorMsg[0];
    this.loadFlag = false;
  }

  paginate(paginateExtension) {
    this.loadFlag = true;
    this.getList(paginateExtension);
  }

  openEvent($event, event) {
    this.router.navigateByUrl(this.redirect_link + '?id=' + event.id);
  }

  onSearch(value: string) {
    this.searchText = value;
    this.searchHits.next();
  }

  sortDirection(key: string): SortDirection {
    if (this.orderBy !== key) { return null; }
    return this.sortBy === 'asc' ? 'asc' : 'desc';
  }

  ariaSort = ariaSort;

  get pagerRangeLabel(): string {
    const pagination: any = this.metadata;
    if (!pagination?.total) { return ''; }
    const start = 1 + (pagination.current_page - 1) * this.limit;
    const end = pagination.current_page === 1 ? pagination.count : pagination.count + (pagination.current_page - 1) * this.limit;
    return `Showing ${start}–${end} of ${pagination.total}`;
  }

  pagerPrev() {
    this.paginate((this.metadata as any)?.links?.previous);
  }

  pagerNext() {
    this.paginate((this.metadata as any)?.links?.next);
  }

  pagerSelect(page: PagerPage) {
    const links = (this.metadata as any)?.links;
    const url = links?.next || links?.previous;
    if (url) { this.nextpage(page as number, url); }
  }

  exportexcel() {
    this.showExport = true;
  }

  protected passeventExcelResponse(res: any,) {
    this.blob = new Blob([res], { type: 'application/vnd.ms-excel' });
    const downloadURL = window.URL.createObjectURL(res);
    const link = document.createElement('a');
    link.href = downloadURL;
    link.download = "Payarc_Event_Report.xls";
    link.click();

  }
  protected passeventExcelError(err: any) {
    console.log(err);
  }

}
